import * as Yup from "yup"

const validation_schema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  address1: Yup.string().required("Required"),
  address2: Yup.string().required("Required"),
  postcode: Yup.string().required("Required"),
  city: Yup.string().required("Required")
})

export default validation_schema
